import api from '../api/axios';
import {
  AsignacionComision,
  CargaEvaluador,
  CohorteComision,
  CopiarPayload,
  DistribuirPayload,
  OptimizadorConfig,
  ResultadoDistribucion,
} from '../types/comision';

export const comisionService = {
  /** Cohortes (etapa + período) con informes entregados y cuántos faltan por asignar. */
  cohortes: async (): Promise<CohorteComision[]> => {
    const { data } = await api.get<CohorteComision[]>('coordinacion/comisiones/');
    return data;
  },

  /** Distribuye comisiones sobre una cohorte. commit=false → propuesta (dry-run). */
  distribuir: async (payload: DistribuirPayload): Promise<ResultadoDistribucion> => {
    const { data } = await api.post<ResultadoDistribucion>('coordinacion/comisiones/', payload);
    return data;
  },

  /** Trae la comisión que cada estudiante tuvo en otro paso. No escribe: es propuesta. */
  copiar: async (payload: CopiarPayload): Promise<ResultadoDistribucion> => {
    const { data } = await api.post<ResultadoDistribucion>('coordinacion/comisiones/copiar/', payload);
    return data;
  },

  /** Distribución ya publicada de una cohorte (para verla/ajustarla), incl. sin asignar. */
  actual: async (params: { paso: number; ano: number; semestre: number }): Promise<ResultadoDistribucion> => {
    const { data } = await api.get<ResultadoDistribucion>('coordinacion/comisiones/actual/', { params });
    return data;
  },

  /** Carga de cada evaluador fuera de la cohorte (la de la cohorte la suma la pantalla). */
  carga: async (params: { paso: number; ano: number; semestre: number }): Promise<CargaEvaluador[]> => {
    const { data } = await api.get<CargaEvaluador[]>('coordinacion/comisiones/carga/', { params });
    return data;
  },

  /** Publica asignaciones explícitas (propuesta con ajustes manuales). */
  aplicar: async (asignaciones: AsignacionComision[]): Promise<{ aplicadas: number }> => {
    const { data } = await api.post('coordinacion/comisiones/aplicar/', { asignaciones });
    return data;
  },

  /** Parámetros globales del optimizador. */
  optimizador: async (): Promise<OptimizadorConfig> => {
    const { data } = await api.get<OptimizadorConfig>('coordinacion/optimizador/');
    return data;
  },

  /** Guarda los parámetros del optimizador (antes de correr). */
  guardarOptimizador: async (input: OptimizadorConfig): Promise<OptimizadorConfig> => {
    const { data } = await api.patch<OptimizadorConfig>('coordinacion/optimizador/', input);
    return data;
  },
};
